import React, { useEffect } from "react";
import { Skeleton } from "primereact/skeleton";

interface DashboardPageHeaderProps {
  title: string;
  subtitle?: string;
  disclaimer?: string;
  rightContent?: React.ReactNode;
  loading?: boolean;
}

const DashboardPageHeader: React.FC<DashboardPageHeaderProps> = ({
  title,
  subtitle,
  disclaimer,
  rightContent,
  loading = false,
}) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(loading);

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (
      (title && title.trim() !== "") ||
      (subtitle && subtitle.trim() !== "") ||
      (disclaimer && disclaimer.trim() !== "") ||
      rightContent
    ) {
      setIsLoading(false);
    }
  }, [title, subtitle, disclaimer, rightContent]);

  return (
    <div className="flex align-items-start justify-content-between mb-3">
      <div>
        {isLoading ? (
          <Skeleton width="320px" height="2.2rem" className="mb-2" />
        ) : (
          <h2 className="m-0 mb-2 text-3xl font-semibold">{title}</h2>
        )}

        {isLoading ? (
          <Skeleton width="720px" height="1rem" className="mb-2" />
        ) : (
          subtitle && (
            <p
              className="m-0 mb-2 text-sm profile-description line-height-3"
              style={{ maxWidth: 720 }}
            >
              {subtitle}
            </p>
          )
        )}

        {isLoading ? (
          <Skeleton width="200px" height="1rem" className="mb-2" />
        ) : (disclaimer && (
            <p
              className="m-0 mb-2 text-sm profile-description line-height-3"
              style={{ maxWidth: 720, fontStyle: 'italic' }}  
            >
              {disclaimer}
            </p>
        ))}

        <div
          className="p-3 border-round acknowledgment-box"           
        >
          <h4 className="m-0 mb-2 text-base font-semibold ">
            Nexus Platform – User Acknowledgment
          </h4>
          <p className="m-0 mb-2 text-sm line-height-3">
            Participation in the Nexus professional profile platform is
            voluntary. You may choose what information to share, manage your
            profile at any time, and withdraw your participation without
            penalty.
          </p>
          <p className="m-0 text-sm line-height-3">
            Your data will be used only for internal purposes such as
            collaboration, learning, and engagement. It will not be used for
            performance evaluations, employment decisions or shared externally
            without your explicit consent. All data is stored securely and
            accessible only to authorized personnel.
          </p>
        </div>

      </div>
      {rightContent && (
        <div className="flex align-items-center gap-2 ml-3">{rightContent}</div>
      )}
    </div>
  );
};

export default DashboardPageHeader;
